import { useEffect } from "react"
import { addSSEListener } from "./sseService"

export default function useSSEListener(onMessage) {
  useEffect(() => {
    if (!onMessage) return

    const unsubscribe = addSSEListener(onMessage)

    return () => unsubscribe()
  }, [onMessage])
}
